import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getCommercialModification } from './commercialThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearCommercialKey } from '../../sell/sellKeys';
const SLICE_NAME = 'modification';

export const modificationSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearCommercialModification(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({
            builder,
            request: getCommercialModification,
        }).addCase(clearCommercialKey, () => commonInitialState);
    },
});

export const { clearCommercialModification } = modificationSlice.actions;

export const modification = modificationSlice.reducer;
